// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field .input-label{font-size:1.15rem}.field .input-field{margin-bottom:.75rem}`, "",{"version":3,"sources":["webpack://./src/UI/Inputs/Field.scss"],"names":[],"mappings":"AACC,oBACC,iBAAA,CAGD,oBACC,oBAAA","sourcesContent":[".field {\n\t.input-label {\n\t\tfont-size: 1.15rem;\n\t}\n\n\t.input-field {\n\t\tmargin-bottom: 0.75rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
